import { ServiceSubCategory } from '@/commonTypes';
import AppLink from '@/components/common/AppLink';
import { lightBgIcon } from '@/functions/formats';
import MainIcons from '@/icons/main';
import React, { useEffect, useState } from 'react';
import styles from '../../styles.module.css';
import dynamic from 'next/dynamic';
import AppImage from '@/components/common/AppImage';
const Animation = dynamic(() => import('@/components/general/Animation'), {
  ssr: false, // recommended if Animation uses Lottie/window
});

export default function ServiceSubCategoryComponent({
  it,
  index = 0,
  itemClass = '',
}: {
  it?: ServiceSubCategory;
  index: number;
  itemClass?: string;
}) {
  const [icon, setIcon] = useState<any>();
  const [play, setPlay] = useState(false);
  const [serviceJson, setServiceJson] = useState<any>(null);

  useEffect(() => {
    const load = async () => {
      const mod = await import('@/public/imgs/motion/service');
      setServiceJson(mod.default);
    };

    load();
  }, []);
  // console.log('servicejson==', ServiceJson);

  useEffect(() => {
    const loadMotion = async () => {
      if (!it?.key || !serviceJson) return;

      const industry = serviceJson?.find((s: any) => s.id === it.key);

      if (!industry) return;

      const mod = await industry.loadMotion();
      const modHover = await industry.loadMotionHover();
      // setIcon(!play ? mod.default : modHover.default);

      const shine = await import('@/public/imgs/motion/shine3.json');
      setIcon(shine.default); // actual JSON data
    };

    loadMotion();
  }, [it, serviceJson, play]);
  console.log('serviceJson==', serviceJson, it);
  function getFilterClass(i: number, styles: Record<string, string>): string {
    const classes = [styles.dangerFilter, styles.blueFilter, styles.purpleFilter];

    return classes[i % classes.length];
  }
  function lightBg(i: number): string {
    const colors = ['var(--danger-bg)', 'var(--tag-bg)', 'var(--purple-bg)'];

    return colors[i % colors.length];
  }
  return (
    <AppLink
      key={it?.title}
      href={`/service/${it?.slug}`}
      className={`${styles.item} ${itemClass}`}
      onMouseEnter={() => {
        setPlay(true);
      }}
      onMouseLeave={() => {
        setPlay(false);
        // setIcon(null);
      }}
    >
      <div className={styles.itemIcon} style={{ background: lightBg(index), position: 'relative' }}>
        {/* {isValidElement(it?.icon)
                ? cloneElement(it?.icon, {
                    fill: lightBgIcon(index),
                    width: `${'16px'}`,
                    height: `${'16px'}`,
                  })
                : it?.icon} */}
        {/* <p style={{ color: 'var(--purple' }}>hhhh</p> */}
        {/* {!icon ? ( */}
        {/* <MainIcons.notifIcon fill={lightBgIcon(index)} width="16px" height="16px" /> */}
        {it?.image?.name ? (
          <AppImage src={it.image.name} width="30" height="30" className={getFilterClass(index, styles)} />
        ) : serviceJson ? (
          <AppImage
            src={serviceJson?.filter((x: { id?: string | number }) => x.id == it?.key)?.[0]?.src}
            width="30"
            height="30"
            className={getFilterClass(index, styles)}
          />
        ) : (
          <MainIcons.notifIcon fill={lightBgIcon(index)} width="16px" height="16px" />
        )}
        {/* ) : ( */}
        {icon && (
          <div className={`${styles.absoluteAnimation}`}>
            <Animation
              motion={icon}
              speed={0.9}
              // play={play}
              // width={'30px'}
              // height={'30px'}
              width={'42px'}
              height={'42px'}
              // delay={index * 300}
              play={play}
            />
          </div>
        )}
      </div>
      <h3 className={styles.itemLabel}>{it?.title}</h3>
      <MainIcons.arrowIcon className="rotate-rtl" width="16px" height="16px" />
    </AppLink>
  );
}
